import React, {useCallback, useEffect} from "react";
import css from './lookAroundBlock.module.scss'
import classNames from "classnames";
import {observer} from "mobx-react";
import Loading from "components/loading/Loading";
import GoodsType, {goodsTypeEnumMap} from "../../enum/GoodsType";
import showPrice from "../../utils/ShowPrice";
import {useHistory} from "react-router-dom";
import MyRouterUtil from "../../utils/MyRouterUtil";

const Index = ({className, lookAroundStore}) => {

    const {loading, canLoadMoreData, list} = lookAroundStore
    const history = useHistory()

    const scroll = useCallback(async () => {
        if (loading || !canLoadMoreData) {
            return;
        }

        //   文档的真实高度
        const scrollHeight =
            document.documentElement.scrollHeight || document.body.scrollHeight;

        //   浏览器窗口（文档）的可视高度
        const clientHeight =
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;

        //   浏览器向上滚动的高度
        const scrollTop =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;

        const height = scrollHeight - clientHeight;

        if (scrollTop >= height - 1000) {
            lookAroundStore.fetchData()
        }
    }, [loading, canLoadMoreData]);

    useEffect(() => {
        window.addEventListener("scroll", scroll);

        return () => {
            window.removeEventListener("scroll", scroll);
        };
    }, [scroll]);


    // 商品详情
    const toGoodsInfo = ({goodsType, id}) => {
        MyRouterUtil.build({history}).toGoodsInfo({goodsType, id})
        console.log(`goodsType:${goodsType},id:${id}`)
    }

    return (
        <div className={classNames(className, css.root)}>
            <div className={css.container}>
                <div className={css.title}>
                    随便看看
                </div>
                <div className={css.goodsListContainer}>
                    <div className={css.goodsList}>
                        {
                            list.map((item, i) => {
                                const {id, mainPic, name, originPrice, currentPrice, isHot, isPddShop, isJdShop} = item;
                                const isSelf = !isPddShop && !isJdShop

                                let goodsType;
                                if (isPddShop) {
                                    goodsType = GoodsType.PDD
                                } else if (isJdShop) {
                                    goodsType = GoodsType.JD
                                } else {
                                    goodsType = GoodsType.SELF
                                }
                                return (
                                    <div
                                        key={i}
                                        className={css.goods}
                                        onClick={() => toGoodsInfo({goodsType, id})}
                                    >
                                        <div className={css.top}>
                                            <div className={css.imgWrapper}>
                                                <img src={mainPic} alt=""/>
                                            </div>
                                        </div>
                                        <div className={css.bottom}>
                                            <div className={css.name}>
                                                <span className={classNames({
                                                    [css.self]: goodsType === GoodsType.SELF,
                                                    [css.pdd]: goodsType === GoodsType.PDD,
                                                    [css.jd]: goodsType === GoodsType.JD
                                                })}>
                                                   {goodsTypeEnumMap.get(goodsType)}
                                                </span>
                                                {name}
                                            </div>
                                            <div className={css.priceFloor}>
                                                <div className={css.price}>
                                                    {showPrice(currentPrice)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                {loading && (
                    <Loading/>
                )}
            </div>
        </div>
    )
}

export default observer(Index)